import { twMerge } from 'tailwind-merge';
import { PageTitle } from './PageTitle';
import { BackButton } from '@/components/Custom/Button/BackButton';
import { useNavigate } from 'react-router-dom';

interface PageHeaderProps {
  title: string | React.ReactNode;
  subTitle?: string | React.ReactNode;
  subTitleIconClassName?: string;
  totalItems?: number;
  backToLink?: string | number;
  containerClassName?: string;
  pageTitleClassName?: string;
  headingElement?: React.ReactNode;
  actionListElement?: React.ReactNode;
  actionListClassName?: string;
}

export const PageHeader = ({
  title,
  subTitle,
  subTitleIconClassName,
  totalItems,
  backToLink,
  headingElement,
  containerClassName,
  pageTitleClassName,
  actionListElement,
  actionListClassName,
}: PageHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div
      className={twMerge(
        'flex flex-wrap justify-between gap-10 mb-7',
        containerClassName,
      )}
    >
      <div
        className={twMerge(
          'flex flex-1 flex-col gap-0.5',
          backToLink && 'gap-4',
        )}
      >
        <div className="flex gap-3">
          {backToLink && (
            <BackButton
              buttonClassName="w-7 min-w-7 h-7 min-h-7 shadow-lg"
              arrowClassName="text-2sm"
              onClick={() => {
                if (typeof backToLink === 'number') {
                  navigate(backToLink);
                } else {
                  navigate(backToLink);
                }
              }}
            />
          )}
          <PageTitle
            title={title}
            subTitle={subTitle}
            subTitleIconClassName={subTitleIconClassName}
            totalItems={totalItems}
            className={twMerge(
              'text-black-071336 font-normal dark-mode:text-gray-800',
              pageTitleClassName,
            )}
          />
        </div>
        <div className="max-sm:hidden">{headingElement}</div>
      </div>
      {actionListElement && (
        <div
          className={twMerge(
            'flex flex-wrap items-center gap-3 max-md:w-full max-md:justify-center [&>*]:max-md:w-full [&>*]:max-md:h-auto [&>*]:max-md:py-2.5',
            actionListClassName,
          )}
        >
          {actionListElement}
        </div>
      )}
    </div>
  );
};
